import { immutableEmptyArray } from "../lib"

export default function alwaysImmutableEmptyArray(): Array<never> {
  return immutableEmptyArray as unknown as Array<never>
}